export const REQUEST_ADD_COMMENT = 'REQUEST_ADD_COMMENT'
export const REQUEST_MARK_VIEWED = 'REQUEST_MARK_VIEWED'
export const REQUEST_REMOVE = 'REQUEST_REMOVE'
export const REQUEST_SET_COMPLETED = 'REQUEST_SET_COMPLETED'
export const REQUEST_SET_PROCESSED = 'REQUEST_SET_PROCESSED'
